import axios from 'axios';

const API_BASE_URL = 'https://personal-econ-simulator-production.up.railway.app';

export const api = {
  // Get current economic data
  getEconomicData: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/economic-data`);
      return response.data;
    } catch (error) {
      console.error('Error fetching economic data:', error);
      throw error;
    }
  },

  // Run inflation simulation
  runInflationSimulation: async (userProfile, monthsForward = 12) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/simulate/inflation`, {
        user_profile: userProfile,
        months_forward: monthsForward
      });
      return response.data;
    } catch (error) {
      console.error('Error running simulation:', error);
      throw error;
    }
  },

  // Get demo simulation
  getDemoSimulation: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/simulate/inflation/demo`);
      return response.data;
    } catch (error) {
      console.error('Error fetching demo:', error);
      throw error;
    }
  }
};
